<div [hidden]="!ViewReady" fxLayout="column" fxLayoutAlign="start start">
	<h2>Current <span *ngIf="User.CurrentRole !== 'Judge'">School</span><span *ngIf="User.CurrentRole === 'Judge'">District</span>:</h2>
	<div class="school primarycolor500">{{CurrentSchool}}</div>
	<h2>Current School Year:</h2>
	<div class="school primarycolor500">{{CurrentSchoolYear | schoolYear}}</div>

	<h2>Current Notifications:</h2>
	<div *ngIf="LastLogin" class="margin-bottom">
		You last logged in to the <span [innerHTML]="AwardInfo.ShortName | safeHTML"></span> system on {{LastLogin | date:'MMM. d, yyyy'}} ({{LastLogin | date:'h:mm a'}}).
	</div>
	<div *ngIf="Notifications && !!Notifications.length" class="fullwidth">
		<mat-list>
			<mat-list-item *ngFor="let item of Notifications">
				<mat-icon matListIcon>{{item.IconName || 'notifications'}}</mat-icon>
				<p matLine><span [innerHTML]="item.Message | safeHTML"></span></p>
			</mat-list-item>
		</mat-list>
	</div>
	<div *ngIf="!Notifications || !Notifications.length">
		<em>There are no new notifications available at this time.</em>
	</div>
</div>